import axios from "axios";
import Config from "../../config/index";
import {
  UN_REVIEW_INVOICE_DATA_REQUEST,
  UN_REVIEW_INVOICE_DATA_SUCCESS,
  UN_REVIEW_INVOICE_DATA_FAILURE,
  REVIEW_INVOICE_DATA_REQUEST,
  REVIEW_INVOICE_DATA_SUCCESS,
  REVIEW_INVOICE_DATA_FAILURE,
  UPDATE_INVOICE_APPROVE_REQUEST,
  UPDATE_INVOICE_APPROVE_SUCCESS,
  UPDATE_INVOICE_APPROVE_FAILURE,
  UPDATE_INVOICE_REJECT_REQUEST,
  UPDATE_INVOICE_REJECT_SUCCESS,
  UPDATE_INVOICE_REJECT_FAILURE,
  PAYMENT_STATUS_DATA_REQUEST,
  PAYMENT_STATUS_DATA_SUCCESS,
  PAYMENT_STATUS_DATA_FAILURE,
  UPDATE_ACCEPT_PAYMENT_REQUEST,
  UPDATE_ACCEPT_PAYMENT_SUCCESS,
  UPDATE_ACCEPT_PAYMENT_FAILURE,
  
} from "./poInvoiceTypes";
let baseUrl = Config.baseUrl;

const headersWith = (jwtToken) => ({
  headers: { Authorization: `Bearer ${jwtToken}` },
});

const unReviewInvoiceRequest = () => ({
  type: UN_REVIEW_INVOICE_DATA_REQUEST,
});

const unReviewInvoiceSuccess = (payload) => ({
  type: UN_REVIEW_INVOICE_DATA_SUCCESS,
  payload,
});

const unReviewInvoiceFailure = (error) => ({
  type: UN_REVIEW_INVOICE_DATA_FAILURE,
  payload: error,
});

const unReviewInvoice = (pageNo, rowsPerPage, search, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(unReviewInvoiceRequest());
    const url = `${baseUrl}/sp/invoice/pending_review?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, null, headers)
      .then((response) => dispatch(unReviewInvoiceSuccess(response.data)))
      .catch((err) => dispatch(unReviewInvoiceFailure(err.message)));
  };
};
const reviewInvoiceRequest = () => ({
  type: REVIEW_INVOICE_DATA_REQUEST,
});
const reviewInvoiceSuccess = (payload) => ({
  type: REVIEW_INVOICE_DATA_SUCCESS,
  payload,
});
const reviewInvoiceFailure = (error) => ({
  type: REVIEW_INVOICE_DATA_FAILURE,
  payload: error,
});
const reviewInvoice = ( pageNo, rowsPerPage, search, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(reviewInvoiceRequest());
    const url = `${baseUrl}/sp/invoice/past_invoice?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, null, headers)
      .then((response) => dispatch(reviewInvoiceSuccess(response.data)))
      .catch((err) => dispatch(reviewInvoiceFailure(err.message)));
  };
};

// APPROVE
const approveInvoiceRequest = () => ({ type: UPDATE_INVOICE_APPROVE_REQUEST });
const approveInvoiceSuccess = (payload) => ({
  type: UPDATE_INVOICE_APPROVE_SUCCESS,
  payload,
});
const approveInvoiceFailure = (error) => ({
  type: UPDATE_INVOICE_APPROVE_FAILURE,
  payload: error,
});

const approveInvoice = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(approveInvoiceRequest());
    const url = `${baseUrl}/sp/invoice/approve`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(approveInvoiceSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(approveInvoiceFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// REJECT
const rejectInvoiceRequest = () => ({ type: UPDATE_INVOICE_REJECT_REQUEST });
const rejectInvoiceSuccess = (payload) => ({
  type: UPDATE_INVOICE_REJECT_SUCCESS,
  payload,
});
const rejectInvoiceFailure = (error) => ({
  type: UPDATE_INVOICE_REJECT_FAILURE,
  payload: error,
});

const rejectInvoice = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(rejectInvoiceRequest());
    const url = `${baseUrl}/sp/invoice/reject`;
    // const url = `http://10.1.2.115:1880/api/acp/api/swms/sp/invoice/reject`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(rejectInvoiceSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(rejectInvoiceFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


 const paymentStatusRequest = () => ({
  type: PAYMENT_STATUS_DATA_REQUEST,
});

 const paymentStatusSuccess = (payload) => ({
  type: PAYMENT_STATUS_DATA_SUCCESS,
  payload,
});

 const paymentStatusFailure = (error) => ({
  type: PAYMENT_STATUS_DATA_FAILURE,
  payload: error,
});

 const PaymentStatus = (pageNo, rowsPerPage, search, jwtToken) => {
  const headers = headersWith(jwtToken);

  return (dispatch) => {
    dispatch(paymentStatusRequest());

    const url = `${baseUrl}/sp/invoice/payment?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => dispatch(paymentStatusSuccess(response.data)))
      .catch((err) => dispatch(paymentStatusFailure(err.message)));
  };
};


const acceptPaymentRequest = () => ({ type: UPDATE_ACCEPT_PAYMENT_REQUEST });
const acceptPaymentSuccess = (payload) => ({
  type: UPDATE_ACCEPT_PAYMENT_SUCCESS,
  payload,
});
const acceptPaymentFaliure = (error) => ({
  type: UPDATE_ACCEPT_PAYMENT_FAILURE,
  payload: error,
});

const acceptPayment = (payload, jwtToken) => {
  const headers = headersWith(jwtToken);
  return (dispatch) => {
    dispatch(acceptPaymentRequest());
    const url = `${baseUrl}/sp/invoice/mark_paid`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(acceptPaymentSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(acceptPaymentFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { unReviewInvoice, reviewInvoice, approveInvoice, rejectInvoice , PaymentStatus , acceptPayment};
